import type {
  AddressCreateFromGooglePlaceIdApiData,
  AddressCreateFromGooglePlaceIdApiResponses,
  AddressGetApiData,
  AddressGetApiResponses,
  AddressGoogleSuggestionsApiData,
  AddressGoogleSuggestionsApiResponses,
  AddressListApiData,
  AddressListApiResponses,
  GetAddressCityListApiData,
  GetAddressCityListApiResponses,
  GetAddressZipCodeListApiData,
  GetAddressZipCodeListApiResponses,
  NoServiceOfferAddressesListApiData,
  NoServiceOfferAddressesListApiResponses,
  PlaceLocationGetApiData,
  PlaceLocationGetApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getAddressUrls = {
  getPaginatedAddresses: dataEndpoint<AddressListApiData, AddressListApiResponses>({
    getUrl: (queryParams) => apiUrl('addresses/', queryParams)
  }),
  getAddress: dataEndpoint<AddressGetApiData, AddressGetApiResponses>({
    getUrl: ({ addressId }) => apiUrl(`addresses/${addressId}/`)
  }),
  getAddressSuggestions: dataEndpoint<AddressGoogleSuggestionsApiData, AddressGoogleSuggestionsApiResponses>({
    getUrl: (queryParams) => apiUrl('addresses/suggestions/', queryParams)
  }),
  getPlaceLocation: dataEndpoint<PlaceLocationGetApiData, PlaceLocationGetApiResponses>({
    getUrl: (queryParams) => apiUrl('addresses/place-location/', queryParams)
  }),
  postAddressCreatedFromPlaceId: responseEndpoint<
    AddressCreateFromGooglePlaceIdApiData,
    AddressCreateFromGooglePlaceIdApiResponses
  >({
    getUrl: () => apiUrl('addresses/create-from-google-place-id/'),
    getBody: (data) => data
  }),
  getNoServiceOffersList: dataEndpoint<NoServiceOfferAddressesListApiData, NoServiceOfferAddressesListApiResponses>({
    getUrl: (queryParams) => apiUrl('addresses/no-service-offers/', queryParams)
  }),
  getBookingAddressCities: dataEndpoint<GetAddressCityListApiData, GetAddressCityListApiResponses>({
    getUrl: (queryParams) => apiUrl('addresses/cities/', queryParams)
  }),
  getBookingAddressZipCodes: dataEndpoint<GetAddressZipCodeListApiData, GetAddressZipCodeListApiResponses>({
    getUrl: () => apiUrl('addresses/zip-codes/')
  })
};
